import React from 'react'

function BuyerManage() {
  return (
    <div>BuyerManage</div>
  )
}

export default BuyerManage